/**
 * @flow
 */
import TextField from 'components/formik/TextField';
import { Field } from 'formik';
import React from 'react';

type Props = {
  question: Object,
};

const QuestionFormText = ({ question }: Props) => {
  return (
    <Field
      sx={{
        width: '50%',
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        '& div': {
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
        },
        '& textarea': {
          flexGrow: 1,
          overflow: 'scroll !important',
        },
      }}
      multiline
      rows={3}
      rowsMax={20}
      component={TextField}
      type="text"
      name={`answers.${question._id}`}
    />
  );
};

export default QuestionFormText;
